<template>
<div class="chapter">
<div class="inner_page">
<div class="boxch">
<h1 class="toc-title"><a id="page_v"><strong>Contents</strong></a></h1><a id="page_v">
</a></div><a id="page_v">
</a><p class="toc-fm"><a id="page_v"></a><a href="#/005_Preface#fm-1"><em>Preface</em></a></p>
<p class="toc-fm"><a href="#/006_Abbre#fm-2"><em>Abbreviations</em></a></p>
<p class="toc-chap"><a href="#/007_Chapter01#ch-1"><span class="sp1"><span class="sp0">1.</span> John’s Theological Purpose</span></a></p>
<p class="toc-chap"><span href="#/008_Chapter02#ch-2" title="Link target outside of Sample"><span class="sp1"><span class="sp0">2.</span> The Relation between the Signs and the Discourses</span></span></p>
<p class="toc-chap"><span href="#/009_Chapter03#ch-3" title="Link target outside of Sample"><span class="sp1"><span class="sp0">3.</span> Jesus, the Man</span></span></p>
<p class="toc-chap"><span href="#/010_Chapter04#ch-4" title="Link target outside of Sample"><span class="sp1"><span class="sp0">4.</span> The Christ of God</span></span></p>
<p class="toc-chap"><span href="#/011_Chapter05#ch-5" title="Link target outside of Sample"><span class="sp1"><span class="sp0">5.</span> The Son of God</span></span></p>
<p class="toc-chap"><span href="#/012_Chapter06#ch-6" title="Link target outside of Sample"><span class="sp1"><span class="sp0">6.</span> The “I AM” Sayings</span></span></p>
<p class="toc-chap"><span href="#/013_Chapter07#ch-7" title="Link target outside of Sample"><span class="sp1"><span class="sp0">7.</span> God the Father</span></span></p>
<p class="toc-chap"><span href="#/014_Chapter08#ch-8" title="Link target outside of Sample"><span class="sp1"><span class="sp0">8.</span> The Holy Spirit</span></span></p>
<p class="toc-chap"><span href="#/015_Chapter09#ch-9" title="Link target outside of Sample"><span class="sp1"><span class="sp0">9.</span> “That You May Believe”</span></span></p>
<p class="toc-chap"><span href="#/016_Chapter10#ch-10" title="Link target outside of Sample"><span class="sp1">10.</span> Life</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Contents.vue?b9786ba0